<div class="fx-campaign-setting">
  <div class="row">
    <div class="col">
      <fx-page-header title="{{ 'IB Campaign Setting' }}"></fx-page-header>
    </div>
  </div>
  <div class="card bg-dark-lighter text-white">
    <div class="card-body">
      <div class="row">
        <div class="col fs-16 mb-3">
          <span class="text-green">{{ "IB - " }}</span>
          <span>{{ "Level 0 Setting List" }}</span>
        </div>
      </div>
      <div class="p-15">
        <div class="row mb-15">
          <div class="col-md-6 col-xs-12">
            <div class="input-group search-group">
              <input
                type="text"
                class="form-control bg-dark"
                name="keyword"
                [(ngModel)]="keyword"
                (keyup)="search($event)"
                placeholder="Search"
              />
              <button class="btn btn-main" type="button" (click)="search(null)">
                Search
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-xs-12">
            <div class="table-responsive">
              <table class="rox-table table-bordered bg-dark">
                <thead>
                  <tr>
                    <th class="text-center">ID</th>
                    <th class="text-center">MT5 Group</th>
                    <!-- <th class="text-center">Pip</th>
                    <th class="text-center">Commission (%)</th> -->
                    <!-- <th
                      class="text-center"
                      *ngIf="permission.allowCreating"
                    ></th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of listConfig">
                    <td class="text-center">{{ item.id }}</td>
                    <td class="text-center">
                      <span labelGroup="{{ item.name }}"></span>
                    </td>
                    <!-- <td class="text-center">
                      <input
                        type="number"
                        [(ngModel)]="item.data.pip"
                        [disabled]="!isEdit || currentIndexEdit != item.id"
                      />
                    </td>
                    <td class="text-center">
                      <input
                        type="number"
                        [(ngModel)]="item.data.commission"
                        [disabled]="!isEdit || currentIndexEdit != item.id"
                      />
                    </td>
                    <td class="text-center" *ngIf="permission.allowCreating">
                      <i
                        class="fa fa-save"
                        *ngIf="isEdit && currentIndexEdit == item.id"
                        (click)="onSave(item)"
                      ></i>
                      <i
                        class="fa fa-edit"
                        *ngIf="!isEdit || currentIndexEdit != item.id"
                        (click)="onEdit(item)"
                      ></i>
                      <i
                        class="fa fa-ban"
                        *ngIf="isEdit && currentIndexEdit == item.id"
                        (click)="onEdit(null)"
                      ></i>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
